var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSst(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41956 17.749C7.34704 17.7178 5.61632 16.9635 3.86985 15.7174C1.30181 13.8854 0 11.943 0 9.94327V0H16V9.94327C16 11.943 14.6982 13.8854 12.1308 15.7174C10.3844 16.9635 8.65364 17.7178 8.58113 17.749L8.00034 18L7.41956 17.749ZM8.00034 17.5527L8.41011 17.3756C8.48125 17.345 10.1716 16.6081 11.8825 15.3879C14.3363 13.6371 15.58 11.8052 15.58 9.94394V0.409394H0.420711V9.94327C0.420711 11.8052 1.66506 13.6371 4.11818 15.3872C5.82907 16.6074 7.51943 17.3443 7.59058 17.3749L8.00034 17.552V17.5527ZM1.42973 1.39127V9.94327C1.42973 13.6365 8.00034 16.4783 8.00034 16.4783C8.00034 16.4783 14.571 13.6365 14.571 9.94327V1.39127H1.42973Z",
    fill: "#0245B9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4476 3.02752L3.51892 6.85052V12.1453H8.96011L12.8888 8.32234V3.02752H7.4476ZM7.32789 10.5564H5.15114V8.43817H7.32789V10.5564ZM10.7914 9.68432L8.96011 11.4663V6.84985H4.24336L6.07465 5.06783H10.7914V9.68432Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSst);
export default __webpack_public_path__ + "static/media/sst.6caa319414ee3d0238920a6cfb820f13.svg";
export { ForwardRef as ReactComponent };